import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Label } from '../../../../shared/compass-ui'
import ControlledNumericInput from '../../../shared/ControlledNumericInput'
import TextInputError from '../../../shared/TextInputError'

const RecentApplications: FC = () => {
  const {
    formState: {
      errors: { recentApplications: recentApplicationsError },
    },
  } = useFormContext()

  return (
    <div className="col-span-full md:col-span-3">
      <Label htmlFor="recent-applications-input">{EXTRA_QUESTION_LABELS.recentApplications}</Label>
      <ControlledNumericInput name="recentApplications" id="recent-applications-input" />
      {typeof recentApplicationsError?.message === 'string' && (
        <TextInputError>{recentApplicationsError.message}</TextInputError>
      )}
    </div>
  )
}

export default RecentApplications
